import React from 'react';
import { jsx, css } from '@emotion/core';
import lightOrDark from './colorArrowFunction';

import Arrow from '../Icons/Arrow';

const SlickButtonFixSecondary = ({
  secondaryColor,
  uiVariant,
  children,
  props,
}) => {
  const colorCheck = lightOrDark(secondaryColor);

  const BasicArrowStyle = css`
    z-index: 1000;

    &.slick-prev {
      svg {
        transform: rotate(180deg);
      }
    }

    &:before {
      visibility: hidden;
    }

    svg {
      color: ${colorCheck === 'dark' ? '#ffff' : '#272F3C'};
      background-color: ${secondaryColor};
      border-radius: 50%;
      display: block !important;
      padding: 9px;
      width: 38px;
      height: 38px;
      @media screen and (max-width: 768px) {
        width: 30px;
        height: 30px;
      }

      // &:focus,
      // &:hover,
      // &.active {
      //   opacity: 0.7;
      // }
    }
  `;

  return (
    <span css={BasicArrowStyle} {...props}>
      {children}
    </span>
  );
};

const SlickArrowCircleSecondary = ({
  secondaryColor,
  uiVariant,
  visualVariants,
  ...props
}) => {
  return (
    <SlickButtonFixSecondary
      secondaryColor={secondaryColor}
      uiVariant={uiVariant}
      props={props}
    >
      <span>
        <Arrow />
      </span>
    </SlickButtonFixSecondary>
  );
};

export default SlickArrowCircleSecondary;
